import { TerminationType } from './TerminationType';

export const TerminationTypeOptions = [
    { id: TerminationType.Date, name: 'Date' },
    { id: TerminationType.CUT, name: 'C.U.T.' },
];
